<section class="categories-dashboard mt-3"
         [ngClass]="{'is-collapsed': isPortletCollapse}"
         [attr.aria-label]="'connect.calendar.appointment_categories' | translate">
  <header class="dashboard-header">
    <div class="header-content">
      <h2 class="title" id="categories-title">
        {{ "connect.calendar.appointment_categories" | translate }}
      </h2>

      <div class="header-actions">
        <p-button
          type="button"
          icon="pi pi-pencil"
          iconPos="left"
          severity="success"
          size="small"
          styleClass="categories-edit-btn"
          [label]="'connect.calendar.edit_appointment_categories' | translate"
          (onClick)="navigateToLink('/booking-availabilities/types')"
          [ariaLabel]="'connect.calendar.edit_appointment_categories' | translate">
        </p-button>

        <p-button
          type="button"
          [icon]="isPortletCollapse ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
          severity="secondary"
          [text]="true"
          [rounded]="true"
          size="small"
          styleClass="categories-collapse-btn"
          (onClick)="togglePortlet(isPortletCollapse ? 'down' : 'up')"
          [attr.aria-expanded]="!isPortletCollapse"
          aria-controls="categories-list-region"
          [ariaLabel]="(isPortletCollapse ? 'connect.globals.expand' : 'connect.globals.collapse') | translate">
        </p-button>
      </div>
    </div>
  </header>

  @if (!isPortletCollapse) {
    <div id="categories-list-region" class="categories-container" role="region" aria-labelledby="categories-title">
      <div class="categories-list">
        @for (type of doctorBookingTypes; track type) {
          <p-chip
            [label]="type.name | titlecase"
            [style]="{ 'background-color': type.color }"
            [styleClass]="'category-chip ' + (isDarkColor(type.color) ? 'dark-bg' : 'light-bg')">
          </p-chip>
        }
      </div>
    </div>
  }
</section>